import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import CouponTable from '@accounting/components/tables/coupon-table/coupon-table.vue';

@Component({
  name: 'bpc-coupons',
  components: {
    'bpc-coupon-table': CouponTable,
  },
})
export default class Coupons extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
